// Chiavi di sessionStorage con cui le liste ricordano i filtri
export const SAVED_FILTER_KEYS = [
	'vehicleAvailable-filters',
	'vehiclePromo-filters',
	'vehicleWishlist-filters',
	'pudList-filters',
	'leads',
	'quotationList-filters',
	'userAziende-filters',
	'userActions-filters',
];

export const clearSavedFilters = () =>
	SAVED_FILTER_KEYS.forEach((key) => sessionStorage.removeItem(key));
